var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrevHeroArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 301,
    viewBox: "0 0 195 301",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.969,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4998 0.500191C21.9298 0.161191 27.2638 0.661191 32.4998 2.00019C83.1268 44.2912 133.46 86.9582 183.5 130C196.121 140.502 197.787 152.502 188.5 166C137.833 209.333 87.1668 252.667 36.4998 296C29.0248 300.706 21.0248 301.706 12.4998 299C0.105764 290.799 -2.72824 279.966 3.99976 266.5C48.6858 227.646 93.5188 188.98 138.5 150.5C94.1728 111.676 49.6728 73.0092 4.99976 34.5002C-1.96923 19.2352 1.86477 7.90119 16.4998 0.500191Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevHeroArrow);
export default __webpack_public_path__ + "static/media/prev-hero-arrow.54267a0d376b448dfdd3512f1277eb70.svg";
export { ForwardRef as ReactComponent };